import './ResultBoxSkeleton.css'

export default function ResultBoxSkeleton() {
  const items = [1, 2, 3]

  return (
    <div className="results-box skeleton">
      <section className="my-data">
        <div className="skeleton-pulse header" />
        <ul className="my-data--list">
          {items.map((i) => (
            <li key={`my-${i}`}>
              <div className="skeleton-pulse icon" />
              <div className="skeleton-pulse text" />
            </li>
          ))}
        </ul>
      </section>
      <section className="catalog">
        <div className="skeleton-pulse header" />
        <ul className="catalog--list">
          {items.map((i) => (
            <li key={`cat-${i}`}>
              <div className="skeleton-pulse icon" />
              <div className="skeleton-pulse text" />
            </li>
          ))}
        </ul>
      </section>
    </div>
  )
}
